import React from 'react';
// components
import Iconify from '../../../../components/Iconify';
// ----------------------------------------------------------------------
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EventIcon from '@mui/icons-material/Event';
import { useSelector } from 'react-redux';

// Public function for obtaining proper navbar selections. Configs should not be imported directly
export const getNavConfig = () => {
  const { group } = useSelector(state => state.app);
  if (group === 'clients_zs') {
    return navConfigZS;
  }

  return navConfig;
};

const navConfig = {
  subheader: 'general',
  items: [
    { title: 'Twoje Dane', path: '/client', icon: <Iconify icon={'carbon:user-avatar-filled-alt'} width={20} height={20} /> },
    { title: 'Dane dzieci', path: '/client/participants', icon: <Iconify icon={'tabler:mood-kid'} width={20} height={20} /> },
    { title: 'Aktualny Stan Rozliczeń', path: '/client/settlement', icon: <AttachMoneyIcon /> },
    { title: 'Spis zarezerwowanych imprez', path: '/client/events', icon: <EventIcon /> }
  ],
  paths: [
    '/client',
    '/client/participants',
    '/client/settlement',
    '/client/events'
  ]
};

const navConfigZS = {
  subheader: 'general',
  items: [
    {
      title: 'Strona główna',
      path: '/client-zs',
      icon: <Iconify icon={'material-symbols:home-rounded'} width={20} height={20} />
    },
    {
      title: 'Ustawienia konta',
      path: '/client-zs/settings',
      icon: <Iconify icon={'material-symbols:settings-rounded'} width={20} height={20} />
    },
    {
      title: 'Dokumenty',
      path: '/client-zs/documents',
      icon: <Iconify icon={'material-symbols:description-rounded'} width={20} height={20} />
    },
    {
      title: 'Płatności',
      path: '/client-zs/payments',
      icon: <Iconify icon={'material-symbols:payments-rounded'} width={20} height={20} />
    },
    {
      title: 'Szczegóły wyjazdu',
      path: '/client-zs/event-details',
      icon: <Iconify icon={'material-symbols:luggage-rounded'} width={20} height={20} />
    }
  ],
  paths: [
    '/client-zs',
    '/client-zs/settings',
    '/client-zs/documents',
    '/client-zs/payments',
    '/client-zs/event-details'
  ]
};
